function ComingSoonPlaceholder({ title = 'Coming soon', description }) {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-md">
        {/* Sparkle icon */}
        <div className="mx-auto mb-6">
          <svg className="w-12 h-12 mx-auto" viewBox="0 0 24 24" fill="none" style={{ opacity: 0.2, color: '#C9A94E' }}>
            <path d="M12 2L14.09 8.26L20 9.27L15.55 13.97L16.91 20L12 16.9L7.09 20L8.45 13.97L4 9.27L9.91 8.26L12 2Z" fill="currentColor" />
          </svg>
        </div>

        {/* Title */}
        <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-3">
          {title}
        </h2>

        {/* Description */}
        {description && (
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
            {description}
          </p>
        )}

        {/* Subtext */}
        <p className="text-[13px] text-gray-400 dark:text-gray-500" style={{ opacity: 0.6 }}>
          This feature is currently in development.
        </p>
      </div>
    </div>
  )
}

export default ComingSoonPlaceholder
